import React from 'react'

type AttendancePlainCardProps = {
  pairs: {metric: string; value: string}[]
  theme: 'light' | 'dark'
}

const AttendancePlainCard: React.FC<AttendancePlainCardProps> = ({pairs, theme}) => {
  if (!pairs.length) return null

  const textColor = theme === 'dark' ? '#ffffff' : '#212529'
  const borderColor = theme === 'dark' ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.08)'
  const cardBg = theme === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.03)'
  const isSingleMetric = pairs.length === 1

  return (
    <div
      className={`attendance-plain-card rounded-2 p-2${isSingleMetric ? ' attendance-plain-card--single' : ''}`}
      style={{
        display: isSingleMetric ? 'flex' : 'grid',
        justifyContent: isSingleMetric ? 'center' : undefined,
        alignItems: isSingleMetric ? 'center' : undefined,
        gridTemplateColumns: isSingleMetric ? undefined : 'repeat(auto-fill, minmax(88px, 1fr))',
        gap: 4,
        backgroundColor: cardBg,
        border: `1px solid ${borderColor}`,
      }}
    >
      {pairs.map((pair, idx) => (
        <div
          key={`${pair.metric}-${idx}`}
          className='attendance-plain-card__metric text-center px-2 d-flex flex-column align-items-center justify-content-center'
          style={{minHeight: 52, minWidth: isSingleMetric ? 96 : undefined}}
        >
          <div
            style={{
              fontSize: '0.95rem',
              fontWeight: 700,
              color: textColor,
              lineHeight: 1.2,
              width: '100%',
            }}
          >
            {pair.value}
          </div>
          <div
            style={{
              fontSize: '0.65rem',
              color: theme === 'dark' ? 'rgba(255,255,255,0.6)' : '#6c757d',
              lineHeight: 1.2,
              width: '100%',
            }}
          >
            {pair.metric}
          </div>
        </div>
      ))}
    </div>
  )
}

export default AttendancePlainCard
